module.exports = __webpack_public_path__ + "img/konrad_px.f4f44047.png";